{
  "page": {
    "title": "Inventory",
    "subtitle": "{{count}} SKUs across Shopee, Lazada and TikTok"
  },
  "tab": {
    "all": "All",
    "single": "Single",
    "bundles": "Bundles"
  },
  "type": {
    "single": "Single",
    "bundle": "Bundle"
  },
  "toolbar": {
    "create": "Create SKU",
    "sync": "Sync now",
    "sync_multi": "Sync Multi…",
    "sync_all": "Sync all",
    "export": "Export",
    "bulk_edit": "Bulk edit",
    "import_transfers": "Import transfers",
    "reset_defaults": "Reset to defaults",
    "more": "More",
    "export_csv": "Export CSV",
    "coming_soon": "{{label}} — coming soon",
    "export_done": "Exported {{count}} rows",
    "export_empty": "Nothing to export",
    "export_failed": "Export failed"
  },
  "filter": {
    "all_marketplaces": "All marketplaces",
    "all_statuses": "All statuses",
    "search_placeholder": "Search product or SKU…",
    "brand_unmapped": "Brand: Unmapped"
  },
  "column": {
    "product": "Product",
    "sku": "SKU code",
    "type": "Type",
    "marketplace": "Marketplace",
    "allocation": "Allocation",
    "multiplier": "Multiplier",
    "sellable": "Sellable",
    "fake": "Fake",
    "lock": "Lock",
    "reserved": "Reserved",
    "bundle_reserve": "Bundle reserve",
    "on_hand": "On-hand",
    "last_synced": "Last synced",
    "status": "Status"
  },
  "sort": {
    "sortBy": "Sort by {{column}}",
    "ascending": "Sorted ascending",
    "descending": "Sorted descending",
    "none": "Not sorted"
  },
  "status": {
    "healthy": "Healthy",
    "low_stock": "Low stock",
    "out_of_stock": "Out of stock",
    "oversold": "Oversold"
  },
  "tooltip": {
    "lock": "Quantity manually locked by an operator. Editable via inline edit."
  },
  "state": {
    "loading_rows": "Loading inventory…",
    "no_results": "No SKUs match",
    "no_results_hint": "Try clearing your filters or creating a new SKU.",
    "error": "Failed to load inventory. Try refreshing the page.",
    "retry": "Retry",
    "clear_filters": "Clear filters",
    "no_data": "No SKUs yet"
  },
  "diff": {
    "expected": "Expected",
    "reported": "Reported",
    "diff": "Diff",
    "variance": "Variance"
  },
  "ratio": {
    "shopee": "Shopee %",
    "lazada": "Lazada %",
    "tiktok": "TikTok %",
    "import": "Import ratios",
    "sync_notice": "Ratio changes apply on the next stock-sync cycle, not immediately.",
    "search_placeholder": "Search exact SKU…",
    "search_not_found": "No SKU matches “{{sku}}”.",
    "page": {
      "title": "Inventory ratio",
      "subtitle": "{{count}} SKUs · Shopee / Lazada / TikTok split"
    },
    "column": {
      "sku": "SKU code",
      "sum": "Total",
      "actions": "Actions"
    },
    "action": {
      "save": "Save",
      "reset": "Reset to default"
    },
    "state": {
      "empty": "No SKUs in the catalog yet."
    },
    "error": {
      "sum": "ratio.error.sum"
    },
    "toast": {
      "saved": "Ratio saved.",
      "save_error": "Could not save the ratio. Please try again.",
      "reverted": "Reverted to the default 40/40/20 split.",
      "import_soon": "Ratio import is coming in a later release."
    }
  },
  "empty": {
    "no_skus_match": "No SKUs match",
    "try_clearing": "Try clearing your filters or creating a new SKU."
  },
  "bulk": {
    "skus_selected": "{{count}} SKUs selected",
    "reset_done": "Reset {{count}} rows to defaults",
    "reset_error": "Reset failed — please try again",
    "edit": {
      "title": "Bulk edit",
      "subtitle": "Editing {{count}} rows",
      "field_multiplier": "Multiplier",
      "field_fake": "Fake",
      "field_lock": "Lock",
      "placeholder_unchanged": "Leave blank to keep unchanged",
      "at_least_one": "Fill at least one field",
      "invalid_multiplier": "Multiplier must be a number between 0 and 1 (use '.')",
      "invalid_integer": "Must be a whole number of 0 or more",
      "action_apply": "Apply to selected",
      "action_applying": "Applying…",
      "action_cancel": "Cancel",
      "success": "Updated {{count}} rows"
    },
    "sync": "Sync to marketplace",
    "sync_done": "Pushed {{count}} rows to their marketplaces",
    "sync_partial": "{{failed}} of {{count}} rows failed to push — see Push history",
    "sync_error": "Sync failed — please try again"
  },
  "modal": {
    "create_sku_bundle": {
      "title": "Create SKU/Bundle",
      "is_bundle": "Is Bundle",
      "field_name": "Product name",
      "placeholder_name": "e.g. Travel Mug 400ml",
      "field_code": "SKU / Bundle Code",
      "placeholder_code": "e.g. 0009999",
      "hint": "Creates one SKU with a stock row per marketplace (Shopee, Lazada, TikTok).",
      "components_legend": "Components",
      "components_empty_hint": "Search and add a base product",
      "picker_placeholder": "Search product…",
      "picker_searching": "Searching…",
      "picker_no_results": "No products found",
      "multiplier": "Multiplier",
      "action_remove_component": "Remove component",
      "action_create": "Create",
      "action_cancel": "Cancel",
      "field_ap_name": "Brand (AP)",
      "placeholder_ap_name": "e.g. TONG GARDEN — leave empty if unknown"
    },
    "edit_sku": {
      "title": "Edit SKU",
      "field_name": "Product name",
      "action_save": "Save",
      "action_saving": "Saving…",
      "action_cancel": "Cancel",
      "success": "SKU {{sku}} updated"
    }
  },
  "confirm": {
    "delete_sku": {
      "title": "Delete SKU",
      "description": "This action cannot be undone. Type DELETE to confirm.",
      "type_to_confirm": "Type DELETE to confirm",
      "action_delete": "Delete",
      "action_cancel": "Cancel",
      "success": "SKU {{sku}} deleted"
    },
    "reset_row": {
      "title": "Reset row to defaults?",
      "description": "This resets the multiplier, fake, and lock for {{sku}} / {{mkp}} back to their default values.",
      "action_reset": "Reset",
      "action_cancel": "Cancel"
    }
  },
  "action": {
    "delete_sku": "Delete SKU",
    "edit_product": "Edit product",
    "transfer": "Transfer stock",
    "audit": "Audit log",
    "calculate": "Calculate (recompute)",
    "calculate_done": "Recalculated {{sku}}",
    "calculate_error": "Recalculation failed — please try again",
    "sync": "Sync to marketplace",
    "check_sellername": "Check Sellername",
    "reset_defaults": "Reset row to defaults",
    "reset_defaults_done": "Reset {{sku}} to defaults",
    "set_default": "Reset to default",
    "set_default_aria": "Reset {{field}} to default"
  },
  "audit": {
    "drawer_title": "Audit log",
    "filter_all": "All fields",
    "filter_notable": "Notable+",
    "export_csv": "Export CSV",
    "empty": "No audit history yet.",
    "actor_system": "system",
    "sev_info": "INFO",
    "sev_notable": "NOTABLE",
    "sev_high": "HIGH",
    "error": "Failed to load audit log. Please try again.",
    "retry": "Retry",
    "time_utc_suffix": "({{utc}} UTC)",
    "order_context": "Order {{id}}",
    "view_in_log": "View in Audit Log"
  },
  "transfer": {
    "title": "Transfer stock",
    "route": "Route",
    "qty": "Quantity",
    "from": "From",
    "to": "To",
    "confirm": "Confirm transfer",
    "cancel": "Cancel",
    "preview_onhand": "{{mkp}} on-hand",
    "err_same": "Source and destination must differ",
    "err_qty": "Quantity must be greater than 0",
    "warn_oversold": "Source would go oversold",
    "toast_done": "Transferred {{qty}} from {{from}} to {{to}}",
    "toast_error": "Transfer failed. Please try again.",
    "err_insufficient": "Insufficient stock — another operation may have reduced the available quantity."
  },
  "sync": {
    "toast_done": "Synced {{sku}} to {{mkp}}",
    "toast_failed": "Sync of {{sku}} failed: {{message}}",
    "toast_error": "Could not sync {{sku}}. Please try again.",
    "rate_limited": "Rate limited — try again shortly.",
    "not_available": "Marketplace stock push isn't available yet"
  },
  "sync_multi": {
    "title": "Sync Multi",
    "subtitle": "Paste SKUs to push their allocation to the marketplace in one batch.",
    "marketplace": "Marketplace",
    "skus_label": "SKUs",
    "skus_count": "{{count}} SKUs",
    "skus_placeholder": "Paste one SKU per line…",
    "submit": "Sync {{count}} SKUs",
    "submitting": "Syncing…",
    "close": "Close",
    "col_sku": "SKU",
    "col_result": "Result",
    "col_message": "Message",
    "ok": "OK",
    "failed": "Failed",
    "toast_done": "Synced {{count}} SKUs",
    "toast_partial": "Synced {{ok}}, {{failed}} failed",
    "toast_error": "Sync Multi failed. Please try again."
  },
  "seller_ref": {
    "title": "Check Sellername",
    "subtitle": "{{sku}} · {{mkp}}",
    "col_seller_id": "Seller ID",
    "col_product_id": "Product ID",
    "col_seller_name": "Seller Name",
    "loading": "Looking up listing identities…",
    "empty": "No mapping found for this SKU on {{mkp}}.",
    "error": "Failed to look up Sellername. Please try again.",
    "not_available": "Marketplace integration not available yet. Check back after direct integration goes live.",
    "retry": "Retry",
    "close": "Close"
  },
  "remark": {
    "label": "Remark (optional)",
    "placeholder": "Add a note for the audit log…"
  },
  "bundle": {
    "toolbar": {
      "create": "Create bundle"
    },
    "column": {
      "code": "Bundle code",
      "name": "Product name",
      "components": "Components",
      "actions": "Actions"
    },
    "action": {
      "edit": "Edit",
      "delete": "Delete",
      "recompute": "Recompute"
    },
    "state": {
      "no_data": "No bundles yet",
      "no_data_hint": "Create a bundle to map base SKUs to a marketplace product.",
      "error": "Could not load bundles",
      "retry": "Try again"
    },
    "modal": {
      "edit": {
        "title": "Edit bundle"
      },
      "field_code": "Bundle code",
      "field_name": "Product name",
      "placeholder_name": "Marketplace product name",
      "components_legend": "Components",
      "placeholder_multiplicity": "Qty",
      "action_remove_component": "Remove component",
      "sellable_legend": "Computed sellable per marketplace",
      "sellable_loading": "Calculating sellable…",
      "sellable_empty": "No computed sellable available yet.",
      "action_cancel": "Cancel",
      "action_save": "Save",
      "action_saving": "Saving…"
    },
    "confirm": {
      "delete": {
        "title": "Delete bundle",
        "description": "This permanently removes the bundle \"{{code}}\". This cannot be undone.",
        "type_to_confirm": "Type DELETE to confirm",
        "action_delete": "Delete",
        "action_cancel": "Cancel",
        "success": "Bundle {{code}} deleted"
      }
    },
    "toast": {
      "created": "Bundle {{code}} created",
      "updated": "Bundle {{code}} updated",
      "recomputed": "Recomputed {{code}} ({{mkp}})",
      "recompute_error": "Could not recompute {{code}}"
    }
  },
  "synced": {
    "never": "—",
    "pending": "pending · synced {{rel}} ⚠",
    "failed": "failed {{rel}} ✖",
    "no_listing": "— no listing"
  },
  "row": {
    "sync_now": "Sync now",
    "push_history": "Push history"
  },
  "push": {
    "paused": {
      "title": "Stock push paused for {{mkp}}",
      "body": "{{reason}}. Review the held rows and send them, or fix the stock and press Resume push.",
      "truncated": "Showing the first {{shown}} of {{total}} held rows — push will not resume automatically after this send; review the rest, then Resume push.",
      "body_no_reason": "Review the held rows and send them, or fix the stock and press Resume push."
    },
    "review": "Review",
    "resume": "Resume push",
    "sent_admin_resume": "Stock sent. An admin must resume live push.",
    "history": {
      "title": "Push history — {{sku}} · {{mkp}}",
      "sent": "sent {{qty}} ({{alloc}} + {{reserved}} reserved)",
      "empty": "No push history yet.",
      "failed": "failed: {{error}}",
      "result": {
        "shadow": "shadow: logged, not sent",
        "no_listing": "no marketplace listing",
        "held_multi_warehouse": "held: multi-warehouse shop",
        "held_breaker": "held by circuit breaker",
        "disabled": "push disabled"
      },
      "reason": {
        "loop": "scheduled",
        "fast_path": "instant (stock hit 0)",
        "sync": "manual sync",
        "sync_multi": "Sync Multi",
        "drift": "drift re-queue",
        "resume": "resume"
      }
    }
  },
  "unmapped": {
    "title": "SKUs without a brand",
    "subtitle": "{{count}} SKUs without a brand",
    "caption": "{{n}} SKUs — send this list to sales, then re-upload the brand CSV.",
    "copy": "Copy list",
    "copied": "Copied {{n}} SKUs",
    "copy_failed": "Couldn't copy the list — copy it manually instead",
    "empty": "Every SKU has a brand"
  },
  "brands": {
    "title": "SKU brands",
    "subtitle": "Upload the sales team's brand sheet as CSV. Only the brand columns change; unknown SKUs are listed, never created.",
    "upload_title": "Brand CSV",
    "header_label": "Expected header",
    "copy": "Copy",
    "copied": "Copied",
    "copy_failed": "Couldn't copy — copy it manually instead",
    "file_label": "CSV file",
    "upload": "Upload",
    "uploading": "Uploading…",
    "updated": "Updated",
    "skipped": "Skipped",
    "unknown_count": "Unknown SKUs",
    "unknown_capped": "Showing first {{shown}} of {{total}}",
    "copy_unknown": "Copy unknown SKUs",
    "last_upload": "Last upload: {{who}} · {{when}} · {{updated}} updated, {{unknown}} unknown",
    "no_upload": "No upload yet",
    "failed": "Upload failed: {{reason}}",
    "error_line": "Line {{line}}",
    "view_unmapped": "View unmapped SKUs →"
  }
}
